module.exports = "/assets/b05a9a27c5e0f19c1779223840b727e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/A3.png
// module id = 2310
// module chunks = 0